import React from "react";
import withStyles from "react-jss";
import { Col } from "ComponentsUI/Styles/Grid";
import Container from "reactstrap/lib/Container";
import Row from "reactstrap/lib/Row";

const styles = (theme) => {
	return {
		root: {
			backgroundColor: theme.palette.colors.transparent,
			position: "relative",
			marginBottom: "60px",
		},
		[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
			root: {
				marginBottom: "40px",
			},
		},
		[`@media (max-width: ${theme.media.sm})`]: {
			root: {
				marginBottom: "20px",
			},
		},
	};
};

class RatingList extends React.Component {
	static defaultProps = {
		children: [],
	};

	render() {
		let classes = this.props.classes;
		let blocks = [];
		let block = [];
		React.Children.forEach(this.props.children, (item, index) => {
			if (item.props.isWrapped) {
				block.push(item);
			} else {
				if (block.length > 0) {
					blocks.push(<div key={index - 1}>{block}</div>);
					block = [];
				}
				blocks.push(<div key={index}>{item}</div>);
			}
		});
		if (block.length > 0) {
			blocks.push(<div key="last">{block}</div>);
		}
		return (
			<div className={classes.root}>
				<Container>
					<Row>
						<Col sm="12">{blocks}</Col>
					</Row>
				</Container>
			</div>
		);
	}
}

export default withStyles(styles)(RatingList);
